import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import FocusLock from 'react-focus-lock';
import { preferReducedMotion } from '../../styles/animation.js';
import { animationDuration } from '../../styles/variables.js';
import { isTargetInsideContainer } from '../../utils/DomUtils.js';
import { Key } from '../../utils/Keys.js';
import { TransitionHandler } from '../../utils/transition.js';
import { DrawerPresentation, addDrawerOpenListeners, addScrollLock, removeDrawerOpenListeners, removeScrollLock } from './DrawerPresentation.js';

var DrawerWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(DrawerWrapper, _React$Component);
  var _super = _createSuper(DrawerWrapper);
  function DrawerWrapper(props) {
    var _this;
    _classCallCheck(this, DrawerWrapper);
    _this = _super.call(this, props);
    _this.onKeyDown = function (e) {
      switch (e.key) {
        case Key.Escape:
          e.preventDefault();
          _this.props.onBackdropClick();
          return;
      }
    };
    _this.handleBodyClick = function (e) {
      if (!_this.host || isTargetInsideContainer(e.target, _this.contentElement)) {
        return;
      }
      e.preventDefault();
      _this.props.onBackdropClick(e);
    };
    _this.transitionHandler = new TransitionHandler();
    _this.state = {
      transitionState: _this.transitionHandler.makeTransitionState("unmounted")
    };
    return _this;
  }
  _createClass(DrawerWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        addDrawerOpenListeners(this.onKeyDown);
        if (this.props.layout !== "mega-menu") {
          addScrollLock();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeDrawerOpenListeners(this.onKeyDown);
      removeScrollLock();
      this.transitionHandler.stopTransitions();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;
      // onOpenChange
      // this.props.open can sometimes be undefined, and sometimes false. In this case, !== is false.
      // that's the reason for the !. The linter does not like !=.
      if (!this.props.open !== !prevProps.open) {
        var reduceAnimation = preferReducedMotion() ? 0 : animationDuration.slower;
        this.transitionHandler.transition(this.props.open, reduceAnimation, this.state.transitionState, function (transitionState) {
          _this2.setState({
            transitionState: transitionState
          });
        });
        if (!prevProps.open && this.props.open) {
          addDrawerOpenListeners(this.onKeyDown);
          if (this.props.layout !== "mega-menu") {
            addScrollLock();
          }
        } else if (prevProps && !this.props.open) {
          removeDrawerOpenListeners(this.onKeyDown);
          removeScrollLock();
        }
      }
      // onLayoutChange
      if (this.props.layout !== prevProps.layout && this.props.open) {
        if (prevProps.layout === "mega-menu" && this.props.layout !== "mega-menu") {
          addScrollLock();
        } else if (prevProps.layout !== "mega-menu" && this.props.layout === "mega-menu") {
          removeScrollLock();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        noFocusLock = _this$props.noFocusLock,
        open = _this$props.open,
        _onBackdropClick = _this$props.onBackdropClick;
      return /*#__PURE__*/React.createElement(FocusLock, {
        disabled: noFocusLock || !open
      }, /*#__PURE__*/React.createElement(DrawerPresentation, Object.assign({}, this.props, {
        onBackdropClick: function onBackdropClick(e) {
          _onBackdropClick(e);
        },
        contentRef: function contentRef(r) {
          return _this3.contentElement = r;
        },
        ref: function ref(r) {
          return _this3.host = r;
        },
        transitionState: this.state.transitionState
      })));
    }
  }]);
  return DrawerWrapper;
}(React.Component);
DrawerWrapper.defaultProps = Object.assign(Object.assign({}, DrawerPresentation.defaultProps), {
  onBackdropClick: function onBackdropClick() {
    /* empty */
  }
});

export { DrawerWrapper };
